/*
 *            ██╗██╗
 * ███╗   ██╗ █████╗ ████████╗██╗  ██╗██╗      ██████╗ ██╗  ██╗
 * ████╗  ██║██╔══██╗╚══██╔══╝██║ ██╔╝██║     ██╔═══██╗██║ ██╔╝
 * ██╔██╗ ██║███████║   ██║   █████╔╝ ██║     ██║   ██║█████╔╝
 * ██║╚██╗██║██╔══██║   ██║   ██╔═██╗ ██║     ██║   ██║██╔═██╗
 * ██║ ╚████║██║  ██║   ██║   ██║  ██╗███████╗╚██████╔╝██║  ██╗
 * ╚═╝  ╚═══╝╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝╚══════╝ ╚═════╝ ╚═╝  ╚═╝
 *
 * Global configuration for Nätklok
 * --------------------------------
 * Added in v1.3.0
 *
 *
 *
 */

/**
 *
 * Which "profiles", or activities online, the user
 * can choose at the beginning of the test.
 */
export const profiles = ["gamer", "banker", "movie-watcher", "on-social-media", "general"] as const;

/**
 *
 * Different age groups enables us to target important
 * questions to the right user.
 */
export const ages = ["youth", "adult", "elderly"] as const;

/**
 *
 * Languages that the test currently is translated to.
 */
export const languages = ["sv", "en"] as const;

/**
 *
 * Which badges the test should categorize its questions
 * into. the sv/en values appear in the URL.
 */
export const badges = {
  passwords: {
    sv: "losenord",
    en: "passwords",
  },
  phishing: {
    sv: "phishing",
    en: "phishing",
  },
  theft: {
    sv: "stold-online",
    en: "theft",
  },
  connected: {
    sv: "uppkopplad",
    en: "connected",
  },
  onlineChat: {
    sv: "i-chatten",
    en: "online-chat",
  },
  malware: {
    sv: "skadeprogram",
    en: "malware",
  },
  surfOnline: {
    sv: "surfa-online",
    en: "surf-online",
  },
} as const;
export const badgeIds = Object.keys(badges);

/**
 *
 * All templates used to render questions. These can be
 * dynamic, or simply choice-questions.
 */
export const renderTemplates = [
  "yes-no",
  "who-is-right",
  "several-option",
  "test-password-strength",
  "chat-answer",
  "fake-website",
  "fake-domain",
  "search-engine-results",
  "order-correctly",
  "match-statements",
  "circle-or-cross-out",
  "content-is-scam-or-not",
  "image-is-scam-or-not",
] as const;

/**
 *
 * Which keys the questions-object is filterable by
 */
export const availableFilters = [
  "questionVariant",
  "id",
  "fitsAges",
  "fitsProfiles",
  "badgeId",
] as const;
